<script>
import { TOKEN_SESSION, USER } from '../stores'
import { createEventDispatcher } from 'svelte';
import { onMount } from 'svelte';
import * as Fx from '../globals/Fx'
import Navbar from './Navbar.svelte';
import Menuflat from './Menuflat.svelte';
import Home from './Home.svelte';
import Suscriptores from './Suscriptores.svelte';
import Liquidaciones from './Liquidaciones.svelte';
import Reportes from './Reportes/Reportes.svelte';
import ScreenConfiguraciones from './configuraciones/ScreenConfiguraciones.svelte';

let opciones  = [
    { active: false,name : "Home", desc : "Home", icon : "home-outline", backgroundColor :"#f39c12", color:"#fff"},
    { active: false,name : "Suscriptores", desc : "Administrar Suscriptores", icon : "people-outline", backgroundColor :"#f39c12", color:"#fff"},
    { active: false,name : "Liquidar", desc : "Procesar Liquidaciones", icon : "settings-outline", backgroundColor :"#3498db", color:"#fff"},
    { active: false,name : "Reportes", desc : "Revisión de Datos", icon : "podium-outline", backgroundColor :"#2ecc71", color:"#fff"},
    { active: false,name : "Configuraciones", desc : "Configuraciones", icon : "cog", backgroundColor :"#2ecc71", color:"#fff"},
    { active: false,name : "Salir", desc : "Salir", icon : "exit-outline", backgroundColor :"#e74c3c", color:"#fff"},
]


let opcionActual = "Home"
const dispatch = createEventDispatcher()

/*  BORRAR esto en produccion */
// opciones[0].active = false
// opciones[2].active = true
// opcionActual = "Liquidar"
/*   ....  */

onMount (async () => {
    if (!$USER) 
      USER.set(JSON.parse(Fx._retrieveData("userInfo")))
})

const closeSession = () => {
    dispatch('closeSession',{})
}

const _click_opcion = (event) => {
    switch(event.detail.opcion) {
        case "Home" : 

        break;
        case "Salir" : 
            closeSession()
        break;
        case "Suscriptores" :
        break;
        case "Reportes" :
        break;
        case "Liquidar" :
        break;
    }
    opcionActual = event.detail.opcion
    opciones.forEach((item,idx) => {
        if (item.name === opcionActual) 
            opciones[idx].active = true
        else
            opciones[idx].active = false
    });
}

</script>

<div>
    {#if opciones}
         <Menuflat opciones = {opciones} on:_click_opcion={_click_opcion}/> 
    {/if}
    <Navbar />
    <div class="content-section">
        {#if opcionActual === "Home"}
            <Home/>
        {:else if  opcionActual === "Suscriptores"}
             <Suscriptores />
        {:else if  opcionActual === "Liquidar"}
             <Liquidaciones />
        {:else if  opcionActual === "Reportes"}
             <Reportes/>
        {:else if  opcionActual === "Configuraciones"}
             <ScreenConfiguraciones/>
        {/if}
       
    </div>
    
</div>

<style>
    .content-section {
        height: 100vh;
        background-color: rgb(255, 255, 255);
        padding-top: 80px;
        padding-left: 60px;
        /* padding-right: 5px; */
        overflow-y: hidden;
    }
</style>
